import { Col } from "react-flexbox-grid";
import styled from "styled-components";
import { Container } from "../../components/atoms/Container";
import LinkWineScreen from "../../components/atoms/LinkWineScreen";
import sortArrow from "../../assets/images/icons/arrow-down.svg";
import breakpoints from "../../styles/breakpoints";
import { colors, fonts } from "../../styles/variables";

export const PageWrapper = styled.div``;

/* Coral title strip. Layout pads <main> on Capacitor for the cart
 * toggle + notch, so this stays plain. */
export const PageTitleWrapper = styled.div`
  background-color: ${colors.coral};
`;

export const PageTitleContainer = styled(Container)`
  display: flex;
  flex-direction: row;
  padding: 40px 30px;
  justify-content: space-between;
`;

export const PageTitle = styled.div`
  font-family: ${fonts.fontInterstateUltraBlack};
  font-size: 50px;
  line-height: 45px;
  text-transform: uppercase;
  margin-top: auto;
  margin-bottom: auto;

  ${breakpoints.smDown} {
    font-size: 40px;
    line-height: 36px;
  }
`;

export const StoreContainer = styled(Container)`
  padding: 30px 15px;

  ${breakpoints.mdDown} {
    padding: 20px 15px;
  }
`;

export const StoreListWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  margin: 0 -8px;
`;

export const StoreToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 25px;
  margin-bottom: 35px;

  ${breakpoints.smDown} {
    flex-direction: column;
    gap: 20px;
  }
`;

export const StoreOptions = styled.nav`
  display: flex;
  align-items: center;
  width: 50%;
  padding-right: 25px;

  ${breakpoints.smDown} {
    width: 100%;
    justify-content: center;
  }
`;

export const StoreOption = styled(LinkWineScreen)<{ selected: boolean }>`
  width: 55%;
`;

export const StoreSelectors = styled.div`
  display: flex;
  gap: 15px;
  width: 50%;

  ${breakpoints.smDown} {
    width: 100%;
  }
`;

export const SortControl = styled.label`
  position: relative;
  border: 1px solid black;
  width: 60%;
  height: 60px;
  min-width: 0;

  span {
    position: absolute;
    top: 8px;
    left: 10px;
    font-family: ${fonts.fontInterstateUltraBlack};
    font-size: 10px;
    text-transform: uppercase;
    pointer-events: none;
  }
`;

export const SortSelect = styled.select`
  width: 100%;
  height: 100%;
  appearance: none;
  border: 0;
  border-radius: 0;
  padding: 22px 30px 5px 10px;
  background: url("${sortArrow}") no-repeat right 10px center / 12px;
  color: ${colors.black};
  font-family: ${fonts.fontBauRegular};
  font-size: 10px;
  text-transform: uppercase;
  cursor: pointer;
`;

export const FilterControl = styled.div`
  width: 40%;
`;

export const ResultsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const EmptyState = styled.div`
  padding: 30px 0;
  text-align: center;
`;

// Mirrors the wine list title in organisms/AllWinesOfWineList/style.
export const CollectionHeading = styled.div`
  display: flex;
  align-items: center;
  min-height: 65px;
`;

export const CollectionTitle = styled.h2`
  font-family: ${fonts.fontInterstateBlackCompressed};
  font-size: 50px;
  margin: 0;

  ${breakpoints.smDown} {
    font-size: 25px;
  }
`;

export const ColComponent = styled(Col)`
  display: flex;
  justify-content: center;
`;
